// extracted by mini-css-extract-plugin
export default {"box":"refundFilterPage_box__C-mmQ","box__content":"refundFilterPage_box__content__Ih4uX"};